import api from 'api/direct-mail';
import handleResponse from './utils/handleResponse';

export const getBusinessRules = () => {
    return handleResponse(
        api().get('/corporate/business-rules/get')
    );
}